import React from 'react';
import {buttonStyle} from './styles';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {withMeta, withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  CART_CHECKOUT_BUTTON_TEXT_DEFAULT,
  DATA_ATTR_LOADING_TEXT,
  LOADING_TEXT,
  CART_CHECKOUT_LOADING_TEXT_DEFAULT,
  DATA_ATTR_PUBLISHABLE_KEY,
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON,
} from '@packages/systems/commerce/constants';
import {SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS} from '@packages/systems/core/constants/SharedConstraintRules';
import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getInPojo, getString} from '@packages/utilities/data-utils';

const CommerceCartCheckoutButton = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes} = props;
  const innerHTML = getString(getInPojo(data, ['attr', 'value']));
  const loadingText = getString(getInPojo(data, ['commerce', LOADING_TEXT]));
  const publishableKey = context.get('ecommPublishableKey');
  return (
    <a
      {...generateAttributes(attributes, classes)}
      {...{
        [DATA_ATTR_LOADING_TEXT]: loadingText,
        [DATA_ATTR_PUBLISHABLE_KEY]: publishableKey,
        [DATA_ATTR_NODE_TYPE]: NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON,
      }}
    >
      {innerHTML}
    </a>
  );
});

const config = createIntegratedAtom({
  displayName: 'Checkout Button',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  constraints: {
    ancestors: [{is: 'CommerceCartForm', rule: 'ExactlyOne'}],
    descendants: SHARED_ANCHOR_NODE_CONSTRAINTS_DESCENDANTS,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          ...buttonStyle,
          display: 'block',
          borderTopLeftRadius: px(2),
          borderTopRightRadius: px(2),
          borderBottomRightRadius: px(2),
          borderBottomLeftRadius: px(2),
          textAlign: 'center',
        },
      },
    },
  },
  render: CommerceCartCheckoutButton,
  fields: {
    attr: withSystem(
      {private: false},
      TRecord({
        href: withSystem(
          {
            private: true,
            defaultValue: '/checkout',
          },
          TText
        ),
        value: withMeta(
          {
            placeholder: 'e.g. ' + CART_CHECKOUT_BUTTON_TEXT_DEFAULT,
          },
          withSystem(
            {
              label: 'Button:',
              defaultValue: CART_CHECKOUT_BUTTON_TEXT_DEFAULT,
            },
            TText
          )
        ),
      })
    ),
    commerce: TRecord({
      type: withSystem(
        {
          defaultValue: 'cart-checkout-button',
          private: true,
        },
        TText
      ),
      [LOADING_TEXT]: withMeta(
        {
          placeholder: 'e.g. ' + CART_CHECKOUT_LOADING_TEXT_DEFAULT,
        },
        withSystem(
          {
            label: 'Waiting:',
            defaultValue: CART_CHECKOUT_LOADING_TEXT_DEFAULT,
          },
          TText
        )
      ),
    }),
  },
});

export default config;
